import { render, staticRenderFns } from "./NFS.vue?vue&type=template&id=58c37d04&"
import script from "./NFS.vue?vue&type=script&lang=js&"
export * from "./NFS.vue?vue&type=script&lang=js&"
import style0 from "./NFS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports